export enum Genders {
  male = "male",
  female = "female",
  nonbinary = "nonbinary",
  unspecified = "unspecified",
}

export enum CounselingType {
  TELEPHONE = "telephone",
  ONLINE = "online",
  VIDEO = "video",
}
